import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { InitStepCounterPage } from './init-step-counter';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    InitStepCounterPage,
  ],
  imports: [
    IonicPageModule.forChild(InitStepCounterPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class InitStepCounterPageModule {}



// WEBPACK FOOTER //
// ./src/pages/init-step-counter/init-step-counter.module.ts